import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { getDateProduction } from "../../../../Base/Services/FechasService";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import Card from "../../../../Base/Components/Card/Card";
import CalendarioOperativo from "../../../../Base/Components/Form/CalendarioOperativo";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { eliminarDetalles, eliminarNotaCompleta, getDetalles, getEncabezado, PagarNotas } from "../../../../API/Finanzas/NotasProveedores/NotasProveedoresRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import NotaCreditoProveedorCRUD from "./NotaCreditoProveedorCRUD";
import { confirmDialog } from "primereact/confirmdialog";
import OrdenesComprasReporte1 from "../../../ERP/Compras/OrdenesCompras/Reporte/OrdenesComprasReporte1";


const NotasCreditoProveedorScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialog, setShowDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedEnc, setSelectedEnc] = useState([]);
  const [selectedDet, setSelectedDet] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const [showDialogReporte, setShowDialogReporte] = useState(false);
  const [Languaje, setLanguaje] = useState('es');
  

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow( toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido." );
      return;
    }
    setLoading(true);
    const fechas = getDateProduction(dates);

    const encabezadoTempo = await getEncabezado(fechas)
    setListadoEnc(encabezadoTempo)

    const detallesTempo = await getDetalles(fechas)
    setListadoDet(detallesTempo)

    setLoading(false);
  };

  const eliminarNota = async (completa) => {
    if (completa) {
      const NotasCompletadas = selectedEnc.filter(nota => nota.IdStatus === 97);
      if(NotasCompletadas?.length > 0){
        toastShow( toast, "warn", "Advertencia", "Algunas notas seleccionadas no se pueden eliminar, ya estan 'Completadas'." );
        return
      }
      const selectedEncFiltrado = selectedEnc.filter(nota => nota.IdStatus !== 97);
      confirmDialog({
        message: "¿Está seguro de eliminar las notas seleccionadas?",
        header: "Eliminar Nota",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const Ids = selectedEncFiltrado.map((nota) => nota.IdNotaCreditoEnc).join(",");
          const result = await eliminarNotaCompleta(Ids);
          setTimeout(() => {            
            toastShow(toast, "success", "Éxito", "Notas eliminadas correctamente.");
            getInfo();
          }, 400);
          setLoading(false);
        },
      });
    
    } else {
      const NotasCompletadas = selectedDet.filter(nota => nota.IdStatus === 97);
      if(NotasCompletadas?.length > 0){
        toastShow( toast, "warn", "Advertencia", "Algunos detalles seleccionadas no se pueden eliminar, ya estan 'Completadas'." );
        return
      }
      const selectedDetFiltrado = selectedDet.filter(nota => nota.IdStatus !== 97);
      confirmDialog({
        message: "¿Está seguro de eliminar los detalles seleccionadas?",
        header: "Eliminar Detalles de Nota",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const Ids = selectedDetFiltrado.map((nota) => nota.IdNotaCreditoDet).join(",");
          const result = await eliminarDetalles(Ids);
          setTimeout(() => {            
            toastShow(toast, "success", "Éxito", "Notas eliminadas correctamente.");
            getInfo();
          }, 400);
          setLoading(false);
        },
      });
    }
  };

  const PagarNota = async () => {
    if (selectedEnc.length > 0) {
      confirmDialog({
        message: "¿Está seguro de pagar la nota de crédito seleccionada?",
        header: "Pagar Nota de Crédito",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          let notasPendientes = selectedEnc.filter(nota => nota.IdStatus !== 97);
          let notasAPagar = selectedEnc.filter(nota => nota.IdStatus === 97);
          let datosEnviar = notasAPagar.map((s) => {
            return {
              ...s,
              Acreditado: !s.Acreditado
            }
          })
          if(notasPendientes?.length > 0){
            toastShow( toast, "warn", "Advertencia", "Algunas notas seleccionadas no se pagaron. Estan en estado 'Pendiente'." );
          }
          setLoading(true);
          setTimeout(async() => {            
            const result = await PagarNotas(datosEnviar)
            if (result[0]?.ESTADO === 1) {
              toastShow(toast, 'success', 'Editado', result[0]?.MENSAJE);
              setSelectedEnc([])
              getInfo()
            } else {
              toastShow(toast, 'error', 'Error', 'Ocurrio un error al momento de pagar la nota de crédito');
            }
          }, 500);
          setLoading(false);
        },
      })
    }
  }

  const columns = [
    {
      field: "IdNotaCreditoEnc",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "FechaEmisionStr",
      header: "Fecaha Emisión",
      headerEn: "Date Emission",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NumeroNota",
      headerEn: "No. Nota",
      header: "No. Nota",
      frozen: 1,
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      // cellEditor: changeEstado,
      // editable: true,
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXXlarge",
    },
    {
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventary",
      className: "Xsmall",
    },
    {
      header: "Memo",
      headerEn: "Memo",
      field: "Memo",
      flex: 1,
      width: 600,
    },

    {
      field: "MontoD",
      header: "Monto $",
      headerEn: "Amount $",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Amount L",
      className: "small",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "Acreditado",
      header: "Pagar",
      width: 70,
      frozen: true,
      alignFrozen: "right",
      Format: "Template",
      body: (data) =>
        data.IdNotaCreditoEnc ? (
          <div
            onClick={() => {}}
            onDoubleClick={(e) => {}}
            className="d-flex flex-row"
            style={{ justifyContent: "center", marginTop: 2 }}
          >
            <Checkbox
              checked={data.Acreditado}
              disabled={data?.IdStatus !== 97}
              onClick={() => {
                if(selectedEnc?.length === 0) setSelectedEnc([data])
                PagarNota();
              }}
            />
          </div>
        ) : null,
      hidden: userAuth.IdRol === 1,
    },

    {
      field: "IdNotaCreditoEnc",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdNotaCreditoEnc > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    selected: selectedEnc,
    setSelected: setSelectedEnc,
    showModal: () => {},
  };

  const columnsDet = [
    {
      field: "IdNotaCreditoDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoDet > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "FechaEmisionStr",
      header: "Fecaha Emisión",
      headerEn: "Date Emission",
      Format: "Date",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedEnc([data]);
        }
      },
    },
    {
      field: "NumeroNota",
      headerEn: "No. Nota",
      header: "No. Nota",
      frozen: 1,
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoEnc > 0) {
          setShowDialog(true);
          setSelectedDet([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      // cellEditor: changeEstado,
      // editable: true,
    },
    {
      field: "PurchaseOrder",
      header: "OC",
      headerEn: "PO",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNotaCreditoDet > 0) {
          setShowDialogReporte(true);
          setSelectedDet([data]);
        }
      },
    },
    {
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventary",
      className: "Xsmall",
    },
    {
      field: "Factura",
      header: "Factura",
      headerEn: "Invoice",
      className: "large",
    },
    {
      field: "CodigoProducto",
      header: "Cod. Producto",
      headerEn: "Product Code",
      className: "Xsmall",
    },
    {
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "large",
    },
    {
      field: "NumeroIngreso",
      header: "Ingreso",
      headerEn: "Entry",
      className: "small",
    },
    {
      header: "Memo",
      headerEn: "Memo",
      field: "Memo",
      flex: 1,
      width: 600,
    },
    {
      field: 'Cantidad',
      header: 'Cantidad',
      headerEn: 'Quantity',
      className: 'Xsmall',
      Format: 'Currency',
      Sumary: 'sum',
      Frozen: true,
      alignFrozen: 'right'
  },
  {
      field: 'PrecioD',
      header: 'Precio $',
      headerEn: 'Price $',
      className: 'Xsmall',
      Format: 'Currency',
      Frozen: true,
      alignFrozen: 'right'
  },
  {
      field: 'MontoD',
      header: 'Monto $',
      headerEn: 'Amount $',
      className: 'Xsmall',
      Format: 'Currency',
      Sumary: 'sum',
      Frozen: true,
      alignFrozen: 'right'
  },
  {
      field: 'PrecioL',
      header: 'Precio L',
      headerEn: 'Price L',
      className: 'Xsmall',
      Format: 'Currency',
      Frozen: true,
      alignFrozen: 'right'
  },
  {
      field: 'MontoL',
      header: 'Monto L',
      headerEn: 'Amount L',
      className: 'Xsmall',
      Format: 'Currency',
      Sumary: 'sum',
      Frozen: true,
      alignFrozen: 'right'
  },

    {
      field: "IdNotaCreditoEnc",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdNotaCreditoEnc > 0) {
              setShowDialog(true);
              setSelectedEnc([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableDet = {
    Columns: columnsDet,
    Data: listadoDet,
    loading: loading,
    selected: selectedDet,
    setSelected: setSelectedDet,
    showModal: () => {},
  };

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "NotasCredito", config.language));
  }, []);

  useEffect(() => {
    setSelectedDet([])
    setSelectedEnc([])
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h2>{getLabel(baseLang, "NotasCredito", config.language)}</h2>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={(e) => setShowDialog(true)}
            />

            {activeIndex === 0 && (
              <Button
                icon="pi pi-times"
                tooltip="Eliminar Nota"
                className="p-button-danger"
                disabled={selectedEnc?.length === 0}
                onClick={(e) => eliminarNota(true)}
              />
            )}
            
            {/* {activeIndex === 1 && (
              <Button
                icon="pi pi-times"
                tooltip="Eliminar Detalles"
                className="p-button-danger"
                disabled={selectedDet?.length === 0}
                onClick={(e) => eliminarNota(false)}
              />
            )} */}
          </div>
        }
        contenido={
          <div className="pt-4">

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Listado">
                <div style={{height: '80vh'}}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>

              <TabPanel header="Detalles">
                <div style={{height: '80vh'}}>
                  <AgGrid table={tableDet} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />
      
      {showDialog && (
        <NotaCreditoProveedorCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          selectedEnc={selectedEnc}
          setSelectedEnc={setSelectedEnc}
          getInfo={getInfo}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      )}

      {showDialogReporte && (
        <OrdenesComprasReporte1
          showReporte={showDialogReporte}
          setShowReporte={setShowDialogReporte}
          selectedDetalle={selectedDet}
          Language={Languaje}
          setLanguaje={setLanguaje}
        />
      )}
            
    </div>
  );
};

export default NotasCreditoProveedorScreen;
